import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ScannerPage } from "@/features/scanner/components/scanner-page";

export const scannerRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/scanner",
  component: ScannerPage,
});
